var render = function () {
  var _vm$$attrs, _vm$$attrs2, _vm$$attrs2$props;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    staticClass: "d-flex flex-column",
    staticStyle: {
      "flex": "1 0 auto"
    }
  }, [_c('v-row', {
    staticClass: "ma-0",
    class: {
      'mb-n10 mb-md-n16': _vm.noDevider
    },
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', _vm._b({
    staticClass: "vertical-table__tit pa-10 px-md-20 py-md-16 page-text font-weight-medium mb-n14 mb-md-0",
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, 'v-col', Object.assign({}, ((_vm$$attrs = _vm.$attrs) === null || _vm$$attrs === void 0 ? void 0 : _vm$$attrs.headerProps) || {}, ((_vm$$attrs2 = _vm.$attrs) === null || _vm$$attrs2 === void 0 ? void 0 : (_vm$$attrs2$props = _vm$$attrs2.props) === null || _vm$$attrs2$props === void 0 ? void 0 : _vm$$attrs2$props.headerProps) || {}), false), [_vm._v(" " + _vm._s(_vm.term) + " "), _vm.required ? _c('span', {
    staticClass: "secondary--text"
  }, [_vm._v("(필수)")]) : _vm._e()]), _c('v-col', {
    staticClass: "vertical-table__contents pa-10 px-md-20 py-md-16 page-text grey-6--text",
    staticStyle: {
      "white-space": "pre-line"
    }
  }, [_vm._t("default")], 2)], 1), !_vm.noDevider ? _c('v-divider', {
    staticClass: "grey-ec"
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }